exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none; }\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none; }\n\nhtml {\n  padding: 30px 10px;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #737373;\n  background: #f0f0f0;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif; }\n\ninput {\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif; }\n\nbody {\n  max-width: 500px;\n  _width: 500px;\n  padding: 30px 20px 50px;\n  border: 1px solid #b3b3b3;\n  border-radius: 4px;\n  margin: 0 auto;\n  box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n  background: #fcfcfc; }\n\nh1 {\n  margin: 0 10px;\n  font-size: 50px;\n  text-align: center; }\n  h1 span {\n    color: #bbb; }\n\nh3 {\n  margin: 1.5em 0 0.5em; }\n\np {\n  margin: 1em 0; }\n\nul {\n  padding: 0 0 0 40px;\n  margin: 1em 0; }\n\n.container {\n  max-width: 380px;\n  _width: 380px;\n  margin: 0 auto; }\n\n.divider {\n  height: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/components/page-not-found/page-not-found.component.scss
// module id = ../../../../../src/app/shared/components/page-not-found/page-not-found.component.scss
// module chunks = main